export default function BgPause(){
    return <div className="bg-pause"/>
}